import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=e80a3232&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=e80a3232&prod&scoped=true&lang=css"
import style1 from "./contact.vue?vue&type=style&index=1&id=e80a3232&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80a3232",
  null
  
)

export default component.exports